<template>
  <div class="header">
    <div class="logo-container">
      <img class="logo-image" src="https://drchiang.tongxin.com.tw/syncordia/assets/img/contact_us_images/logo1742780241.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TongxinHeader',
}
</script>

<style scoped lang="scss">
.header {
  background: linear-gradient(135deg, #207868 0%, #2a9d8f 100%);
  color: white;
  height: 80px;
  padding: 10px;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 1;
}

.logo-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
}

.logo-image {
  height: 60px;

  @media screen and (min-width: 768px) {
    height: 80px;
  }
}
</style>
